module.exports = __webpack_public_path__ + "static/media/SuccessCall.af1b6adb.svg";